<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <path
      d="M22.1494 23.9375H25.5078"
      stroke="#040325"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5724 23.9375H17.9307"
      stroke="#040325"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <mask
      id="mask0_3592_1094"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <path
        d="M8 8H32V32H8V8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3592_1094)">
      <path
        d="M29.2578 23.9375H31.5312V22.0625C31.5312 20.095 29.9363 18.5 27.9688 18.5H26.4974L24.6401 15.787C23.7138 14.434 22.1796 13.625 20.5399 13.625H18.7316H16.9233C15.2836 13.625 13.7495 14.434 12.8232 15.787L10.9659 18.5C9.48922 18.9146 8.46875 20.261 8.46875 21.7948V23C8.46875 23.5178 8.88847 23.9375 9.40625 23.9375H10.8224"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5724 24.5C14.5724 23.4645 13.7329 22.625 12.6974 22.625C11.6619 22.625 10.8224 23.4645 10.8224 24.5C10.8224 25.5355 11.6619 26.375 12.6974 26.375C13.7329 26.375 14.5724 25.5355 14.5724 24.5Z"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.2578 24.5C29.2578 23.4645 28.4183 22.625 27.3828 22.625C26.3473 22.625 25.5078 23.4645 25.5078 24.5C25.5078 25.5355 26.3473 26.375 27.3828 26.375C28.4183 26.375 29.2578 25.5355 29.2578 24.5Z"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.2251 18.5L23.0929 16.8461C22.5158 16.0032 21.5614 15.5 20.5399 15.5H19.2734V18.5L24.2251 18.5Z"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.3984 15.5H16.9233C15.9018 15.5 14.9474 16.0033 14.3703 16.8462L13.2382 18.5H17.3984V15.5Z"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.2734 20.3867H19.8281"
        stroke="#040325"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
